import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "c-textbox-label"
}
const _hoisted_2 = {
  key: 0,
  class: "c-textbox-label-required"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar" }, null, -1)
const _hoisted_4 = { class: "c-textbox-error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-textbox p-input-icon-right", {
      'is-invalid': _ctx.errorMessage
    }])
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (_ctx.required && !_ctx.data)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Calendar, {
      id: _ctx.label,
      modelValue: _ctx.data,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data) = $event)),
      "append-to": _ctx.appendTo,
      "manual-input": false,
      "min-date": _ctx.minDate,
      "max-date": _ctx.maxDate,
      autocomplete: "off",
      "date-format": "yy-mm-dd",
      onDateSelect: _ctx.onDateSelected
    }, null, 8, ["id", "modelValue", "append-to", "min-date", "max-date", "onDateSelect"]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.errorMessage), 1)
  ], 2))
}